<template>
  <section class="loginReg" :style="{'--panelColor': panelColor}">
    <div class="loginReg-header-container">
      <img :src="accessConfig.headerLogo" alt>
    </div>
    <div class="loginReg-container">
      <img class="loginReg-background-img" :src="accessConfig.validUserView.bg" alt>
      <div class="loginReg-first-container" v-if="accessConfig.validUserView.position=='right'">
        <transition appear name="translate">
        <div class="loginReg-eventLogo" v-html="accessConfig.validUserView.eventLogo"></div>      
        </transition>
      </div>
      <div class="loginReg-second-container">
        <div v-html="accessConfig.validUserView.validUserContainer" style="width:100%"></div>
        <div class="inputs-wrapper">
          <span v-html="accessConfig.validUserView.successMessage" v-if="showLogin"></span>
          <button class="enter-and-send-btn" @click.prevent="loginNow" v-if="showLogin">
            {{accessConfig.validUserView.buttonText}}
            <span style="position:absolute;right:10px;color:#bbbc;margin-left:10px"> {{parseInt(timerCount)}}s</span>
          </button>
          <span v-html="accessConfig.validUserView.failMessage" v-if="showNewMail && accessConfig.validUserView.failMessage && $route.params.email"></span>
          <div class="email-input-wrapper" v-if="!$route.params.email">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="email-input" type="text" placeholder="email" v-model="emailAddress">
          </div>
          <button class="enter-and-send-btn" @click.prevent="newMail" v-if="showNewMail"><p v-html="accessConfig.validUserView.newMailButtonText"></p></button>          
        </div>
      </div>
    </div>  
 <Footer />
  </section>
</template>

<script>
import api from '@/services/api';
import encrypt from '@/services/encrypt';
import Footer from '@/components/general/Footer.vue';

export default {
  name: 'ValidUser',
  components: { Footer },

  data() {
    return {
      accessConfig: {},
      panelColor: 'transparent',
      showNewMail: false,
      showLogin: true,
      loginTimeout: 10000,
      timerCount: 10,
      timerInterval: null,
      timerTimeout: null,
      emailAddress: '',
    };
  },

  methods: {
    validUser() {
      api
        .post(`event/${this.$store.state.eventId}/validMail`, {
          email: this.$route.params.email,
          token: this.$route.params.token,
        })
        .then((response) => {
          // console.log('validMail', { response });
          if (response.isAxiosError) {
            // console.log('ERROR!');
            this.showNewMail = true;
            this.showLogin = false;
          } else {
            this.timerInterval = setInterval(() => {
              this.timerCount--;
            }, 1000);
            this.timerTimeout = setTimeout(() => {
              this.$router
                .push({
                  name: 'Login',
                })
                .catch((err) => {
                  console.log('navigation error', err);
                  alert('Erro no momento do cadastro, por favor, valide seus dados.');
                });
            }, this.loginTimeout);
          }
        })
        .catch((err, data) => {
          // console.log('error', err.response, data);
          alert(this.accessConfig.validUserView.failMessage);
          // this.$modal.show('dialog', {
          //   title: 'Erro',
          //   text: this.accessConfig.validUserView.failMessage,
          //   buttons: [
          //     {
          //       title: 'Ok',
          //       handler: () => {
          //         this.$modal.hide('dialog');
          //       },
          //     },
          //   ],
          // });
        });
    },
    newMail() {
      api
        .post(`event/${this.$store.state.eventId}/retryValidMail`, {
          email: this.$route.params.email ? this.$route.params.email : this.emailAddress,
        })
        .then((response) => {
          // console.log(response);
          if (response.status) {
            alert('Email enviado com sucesso.');
            this.$router.push({ name: 'Login' });
          } else alert('Email não cadastrado');
        })
        .catch((err, data) => {
          console.log('error', err.response, data);
          alert(this.accessConfig.validUserView.failMessage);
        });
    },
    loginNow() {
      this.$router.push({ name: 'Login' });
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    if (this.accessConfig.loginView.panelColor) this.panelColor = this.accessConfig.loginView.panelColor;
    this.validUser();
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
    clearInterval(this.timerTimeout);
  },
};
</script>


<style lang="scss">
</style>